import styled, { css } from 'styled-components';
import Button from 'src/ui/atoms/button';
import { getColorsMap } from 'src/ui/styles/utils/colors';

export const PersonRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  ${({ theme }) => {
    const { main } = getColorsMap(theme, 'link');

    return css`
      color: ${main};

      &:hover {
        color: ${main};
      }
    `;
  }}
`;

export const PersonName = styled.span`
  margin-right: 1rem;
`;

export const AddMoreButton = styled(Button)`
  padding: 0;
`;
